// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18fVa","label":"styles_label__1OFo8"};